import { DefaultFooter } from '@ant-design/pro-components';
import { useIntl } from '@umijs/max';

export default () => {
  const intl = useIntl();
  const defaultMessage = intl.formatMessage({
    id: 'app.copyright.produced',
    defaultMessage: 'Bản quyền thuộc về AnVui',
  });

  const currentYear = new Date().getFullYear();

  return (
    <DefaultFooter
      copyright={`${currentYear} ${defaultMessage}`}
      links={[
        {
          key: 'homepage',
          title: 'An Vui',
          href: 'https://anvui.vn',
          blankTarget: true,
        },
        {
          key: 'merchant',
          title: 'An Vui Merchant',
          href: 'https://quantri.phanmemnhaxe.com',
          blankTarget: true,
        },
        {
          key: 'partner',
          title: 'An Vui Partner',
          href: 'https://partner.phanmemnhaxe.com',
          blankTarget: true,
        },
      ]}
    />
  );
};
